export const APP_TITLE = 'Meme generator';
